export default __webpack_public_path__ + "static/media/7.c13413b8.jpg";